module.exports = __webpack_public_path__ + "assets/gray-pooledUser-ac82c8.svg";